import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'

import { IDataProviderSort } from 'core-components/types'
import { IFetchResult } from 'core/classes/helpers/store/Interfaces'
import { HttpCancel } from 'core/classes/http'
import { CrudHelper } from 'core/types/helpers/CrudHelper'
import Logger from 'core/utils/Logger'

class MetalocatorCategoriesApi {
  public fetchCategories = async (
    cancelObject?: HttpCancel
  ): Promise<IFetchResult<IFormCategories>> => {
    const crudHelper = new CrudHelper(509, 'MetalocatorCategories')
    const sort: IDataProviderSort = { field: 'tag_group', dir: 'asc' }
    const response = await crudHelper
      .read(undefined, sort, undefined, undefined, cancelObject, undefined, true)
      .catch(Logger.error)
    const responseData = response['Data'] || null
    if (responseData && responseData['Errors']) {
      throw new Error(responseData['Errors'])
    }
    return {
      items: (response && response['Data']) || [],
      total: 0,
    }
  }

  public setCategories = async (
    item: any,
    action: 'create' | 'update' | 'delete'
  ): Promise<any> => {
    const crudHelper = new CrudHelper(509, 'MetalocatorCategories')
    const data = await crudHelper[action]([item])
    return (data || []).length ? data[0] : null
  }
}

const metalocatorCategoriesApi = new MetalocatorCategoriesApi()
export { metalocatorCategoriesApi }
